import { render, staticRenderFns } from "./ModifierGroupRequirements.vue?vue&type=template&id=1c38bc9d&scoped=true"
import script from "./ModifierGroupRequirements.vue?vue&type=script&lang=js"
export * from "./ModifierGroupRequirements.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupRequirements.vue?vue&type=style&index=0&id=1c38bc9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38bc9d",
  null
  
)

export default component.exports